import { render, staticRenderFns } from "./DetStadium.vue?vue&type=template&id=7f945ed3&"
import script from "./DetStadium.vue?vue&type=script&lang=js&"
export * from "./DetStadium.vue?vue&type=script&lang=js&"
import style0 from "./DetStadium.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports